module.exports = __webpack_public_path__ + "img/five5Blue.c8252aac.jpg";